import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import useTranslations from '../../../hooks/useTranslations';
import { Container } from '../../../components/view/FormBuilderStatusesView';
import { SimpleFlexContainer } from '../../../components/layouts/ng-layouts/Containers';
import _BackButton from '../../../components/BackButton';
import { FormBuilderIntegrationsContext } from '../engine/FormBuilderIntegrationsEngine';
import { TextString } from '../../../components/Text';
import _Tabs from '../../../components/engine/TabsEngine';
import Tab from '@material-ui/core/Tab';
import _Animation from '../../../components/Animation';
import Button from '../../../components/Button';
import FileUploadEngine from '../../../components/engine/FileUploadEngine';
import InputBase from '../../../components/form/InputBase';
import DisconnectDialog from '../../GeneralDialog';
import Switch from '@material-ui/core/Switch';
import SelectEngine from '../../../components/engine/SelectEngine';

const BackButton = styled(_BackButton)`
  && {
    align-self: baseline;
  }
`;

const BackButtonFlexContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;

  button {
    margin-right: 1.5rem;
  }
`;

const Tabs = styled(_Tabs)`
  && {
    margin-bottom: 1.2em;
  }
`;

const AnimationContainer = styled.div`
  display: flex;
  overflow: hidden;
`;

const Animation = styled(_Animation)`
  && {
    width: 100%;
  }
`;

const H2 = styled.h2`
  margin: 1.2rem 0 0.8rem;
  font-size: 18px;
`;

const SubText = styled.p``;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 0.8rem;
  justify-content: flex-end;
`;

const SettingsPanel = styled.div`
  max-width: 800px;
`;

const SwitchRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const FormBuilderThirdfortView = props => {
  const t = useTranslations();
  const { setCurrentIntegrationPage } = useContext(
    FormBuilderIntegrationsContext
  );
  const {
    AUTHENTICATION: AUTHENTICATION_TAB,
    AUTHENTICATION_FILE: AUTHENTICATION_FILE_TAB,
    AUTHENTICATION_OWN_CREDENTIALS: AUTHENTICATION_OWN_CREDENTIALS_TAB,
    SETTINGS: SETTINGS_TAB
  } = props.TAB_VALUES;

  return (
    <>
      <Container>
        <SimpleFlexContainer>
          <BackButtonFlexContainer>
            <BackButton onClick={() => setCurrentIntegrationPage('')} />
            <TextString content="form-builder.integrations.thirdfort.activate" />
          </BackButtonFlexContainer>
          <Tabs
            value={props.activeTab}
            onChange={(event, newValue) => props.setActiveTab(newValue)}
          >
            <Tab
              label={t('form-builder.integrations.thirdfort.authentication')}
            />
            <Tab label={t('form-builder.integrations.thirdfort.settings')} />
          </Tabs>
          <AnimationContainer>
            <Animation
              in={props.activeTab === AUTHENTICATION_TAB}
              mountOnEnter // very important
              unmountOnExit // very important
              type="slide"
              direction="right"
              timeout={{
                enter: 250,
                exit: 100
              }}
            >
              {/* <H2>{t('form-builder.integrations.thirdfort.upload')}</H2>
              <SubText>
                <TextString content="form-builder.integrations.thirdfort.private" />
              </SubText>
              <FileUploadEngine
                key={'file-count' + props.existingFiles.length}
                acceptedTypes={['pem']}
                onFileDropped={props.onFileDropped}
                existingFiles={props.existingFiles}
              />
              <H2>{t('form-builder.integrations.thirdfort.kid')}</H2>
              <InputBase
                variant="outlined"
                value={props.kid}
                onChange={e => props.setKid(e.target.value)}
                onFocus={() => {}}
                error={false}
                customCSS="width: 50% !important;"
              />
              <H2>{t('form-builder.integrations.thirdfort.username')}</H2>
              <InputBase
                variant="outlined"
                value={props.username}
                onChange={e => props.setUsername(e.target.value)}
                onFocus={() => {}}
                error={false}
                customCSS="width: 50% !important;"
              /> */}
              {props.authenticationPage === 0 && (
                <>
                  <H2>{t('form-builder.integrations.thirdfort.user')}</H2>
                  <SelectEngine
                    searchable
                    data-testid="formbuilder-collaborate-select-admin"
                    value={props.showingUser}
                    valueParser={val => (val && val.value ? val.value : val)}
                    openMenuOptionParser={props.openMenuOptionParser}
                    placeholder={
                      props.showingUser.value
                        ? `${props.showingUser.firstName} ${props.showingUser.lastName}`
                        : t('form-builder.admins.start_typing')
                    }
                    onChange={props.changedDropdown}
                    asyncOptions={props.loadOptions}
                    customCSS={`transition: 0.2s; width: 470px; border: 2px solid #4c84ff !important;`}
                  />
                  <ButtonContainer>
                    {props.thirdfortConnected ? (
                      <>
                        <Button
                          onClick={props.onSaveBtnClicked}
                          disabled={
                            !props.kid ||
                            !props.username ||
                            !props.showingUser ||
                            !props.showingUser.value
                          }
                        >
                          {t(`form-builder.integrations.thirdfort.save`)}
                        </Button>
                        <Button
                          onClick={() => props.setIsDisconnectDialogOpen(true)}
                          variant="outlined"
                          color="secondary"
                        >
                          {t('form-builder.integrations.thirdfort.disconnect')}
                        </Button>
                      </>
                    ) : (
                      <Button onClick={props.onSaveBtnClicked}>
                        {t('form-builder.integrations.thirdfort.connect')}
                      </Button>
                    )}
                  </ButtonContainer>
                </>
              )}
              {props.authenticationPage === 1 && (
                <>
                  <H2>{t('form-builder.integrations.thirdfort.upload')}</H2>
                  <SubText>
                    <TextString content="form-builder.integrations.thirdfort.private" />
                  </SubText>
                  <FileUploadEngine
                    key={'file-count' + props.existingFiles.length}
                    acceptedTypes={['pem']}
                    onFileDropped={props.onFileDropped}
                    existingFiles={props.existingFiles}
                  />
                </>
              )}
              {props.authenticationPage === 2 && (
                <>
                  <H2>{t('form-builder.integrations.thirdfort.kid')}</H2>
                  <InputBase
                    variant="outlined"
                    value={props.kid}
                    onChange={e => props.setKid(e.target.value)}
                    onFocus={() => {}}
                    error={false}
                    customCSS="width: 50% !important;"
                  />
                  <H2>{t('form-builder.integrations.thirdfort.username')}</H2>
                  <InputBase
                    variant="outlined"
                    value={props.username}
                    onChange={e => props.setUsername(e.target.value)}
                    onFocus={() => {}}
                    error={false}
                    customCSS="width: 50% !important;"
                  />
                  <H2>{t('form-builder.integrations.thirdfort.user')}</H2>
                  <SelectEngine
                    searchable
                    data-testid="formbuilder-collaborate-select-admin"
                    value={props.showingUser}
                    valueParser={val => (val && val.value ? val.value : val)}
                    openMenuOptionParser={props.openMenuOptionParser}
                    placeholder={
                      props.showingUser.value
                        ? `${props.showingUser.firstName} ${props.showingUser.lastName}`
                        : t('form-builder.admins.start_typing')
                    }
                    onChange={props.changedDropdown}
                    asyncOptions={props.loadOptions}
                    customCSS={`transition: 0.2s; width: 470px; border: 2px solid #4c84ff !important;`}
                  />
                  <Button onClick={props.onSaveBtnClicked}>
                    {t('form-builder.integrations.thirdfort.connect')}
                  </Button>
                </>
              )}
            </Animation>
            <Animation
              in={props.activeTab === SETTINGS_TAB}
              mountOnEnter // very important
              unmountOnExit // very important
              type="slide"
              direction="left"
              timeout={{
                enter: 250,
                exit: 100
              }}
            >
              <H2>{t('form-builder.integrations.thirdfort.trigger')}</H2>
              <SubText>
                <TextString content="form-builder.integrations.thirdfort.checks" />
              </SubText>
              <SettingsPanel>
                <SwitchRow>
                  <span>
                    {t(`form-builder.integrations.thirdfort.turn_on_ongoing`)}
                  </span>
                  <Switch
                    checked={props.isOngoing}
                    onChange={props.onToggleSwitch}
                    color="primary"
                  />
                </SwitchRow>
              </SettingsPanel>
            </Animation>
          </AnimationContainer>
        </SimpleFlexContainer>
        <DisconnectDialog
          open={props.isDisconnectDialogOpen}
          title="form-builder.integrations.thirdfort.disconnect_title"
          content="form-builder.integrations.thirdfort.disconnect_explanation"
          variant="delete"
          buttons={[
            {
              text: 'dialog.cancel',
              variant: 'outlined'
            },
            {
              text: 'form-builder.integrations.thirdfort.confirm_disconnect',
              color: 'secondary',
              onClick: 'confirm'
            }
          ]}
          handleConfirm={() => {
            props.onDisconnectBtnClicked();
          }}
          handleClose={() => props.setIsDisconnectDialogOpen(false)}
        />
      </Container>
    </>
  );
};

export default FormBuilderThirdfortView;
